import TableHeaderHtmlCustom from '../../../../components/common/customTable/TableHeaderHtmlCustom';
import { useQuery } from '../../../../hooks/UseQuery';
import { moduleConstant } from '../constant';

const style1 = {
  backgroundColor: '#4F81BD',
  color: '#fff',
  minWidth: '100px',
  height: '50px',
};
const style2 = {
  backgroundColor: '#868e96',
  height: '50px',
  color: '#fff',
};

interface IProps {
  isView: boolean;
}

const THead = ({ isView }: IProps) => {
  const date = useQuery('date');
  const year = date && new Date(date).getFullYear();
  const tableHeaderObj = [
    [
      {
        text: `${moduleConstant?.heading} - ${year}`,
        style: style2,
        colspan: 16 + (!isView ? 1 : 0),
      },
    ],
    [
      { text: '', style: style1, rowspan: 2 },
      { text: 'DATE', style: style1, rowspan: 2 },
      { text: 'PART NO ', style: style1, rowspan: 2 },
      { text: 'REJECT QTY ', style: style1, rowspan: 2 },
      { text: 'RESP', style: style1, rowspan: 2 },
      { text: 'STAGE ', style: style1, rowspan: 2 },
      { text: 'PROBLEM ', style: style1, rowspan: 2 },
      { text: 'CONTAINMENT ACTION  ', style: style1, rowspan: 2 },
      { text: 'REWORK/SCRAP ', style: style1, rowspan: 2 },
      { text: '(TIME MIN)  ', style: style1, rowspan: 2 },
      { text: 'REWORK & CHECK BY  ', style: style1, rowspan: 2 },
      { text: 'RE-INSPECTION   ', style: style1, rowspan: 1, colspan: 2 },
      { text: 'CHECED BY QC ', style: style1, rowspan: 2 },
      { text: 'CHECKED BY QA HEAD  ', style: style1, rowspan: 2 },
      { text: 'REMARKS', style: style1, rowspan: 2 },
    ],
    [
      { text: 'OK ', style: style1, colspan: 1 },
      { text: 'NOT OK', style: style1, colspan: 1 },
    ],
  ];

  if (!isView) {
    tableHeaderObj[1].push({
      text: 'ACTION',
      style: style1,
      colspan: 1,
      rowspan: 2,
    });
  }

  return (
    <thead>
      <TableHeaderHtmlCustom tableHeaderObj={tableHeaderObj} />
    </thead>
  );
};

export default THead;
